module.exports = __webpack_public_path__ + "img/20200508_173909.4d887b5c.jpg";